var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group"},[_c('button',{class:[
      'btn',
      'btn-primary-outline',
      't-align-left',
      { 'd-none': _vm.getCurrentStep === 0 } ],on:{"click":function($event){$event.preventDefault();return _vm.formCheck(-1)}}},[_vm._v(" ← 上一步 ")]),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.formCheck(1)}}},[_vm._v(" "+_vm._s(_vm._f("nextBtnText")(_vm.getCurrentStep))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }